import React from 'react';
import c from 'classnames';
import { Menu, CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const MainMenu = ({ menuToggled, setMenuToggled, searchToggled, setSearchToggled, isOnSearchPage }) => {
  const MainMenuMobileClasses = c('MainMenu__mobile', {
    'MainMenu__mobile--active': menuToggled,
  });

  const renderMenu = () => {
    return (
      <Menu id="main-navigation">
        {(items) => {
          return (
            <>
              {items.map((item) => {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url']);
                const classes = c('MainMenu__item__link__title', item.getIn(['link', 'options', 'attributes', 'class', 0], ''));
                const hasChildren = item.getIn(['has_children'], false);
                const routeName = item.getIn(['link', 'route_name'], null);
                const displayMenu = hasChildren && routeName === '<nolink>';

                if (displayMenu) {
                  const subtree = item.getIn(['subtree']);
                  return (
                    <div key={title} className="MainMenu__section">
                      {subtree.map((submenuitem) => {
                        const submenuTitle = submenuitem.getIn(['link', 'title'], 'Untitled');
                        const submenuUrl = submenuitem.getIn(['link', 'url']);
                        const submenuClasses = c('MainMenu__item__link__title', submenuitem.getIn(['link', 'options', 'attributes', 'class', 0], ''));

                        return (
                          <div key={submenuTitle} className="MainMenu__item">
                            <CoreLink className="MainMenu__item__link" to={submenuUrl} onClick={() => { setMenuToggled(false); }}>
                              <div className={submenuClasses}>{submenuTitle} <div className="icon icon-caret icon-variant-5 icon-hover" /></div>
                            </CoreLink>
                          </div>
                        );
                      })}
                    </div>
                  );
                }

                return (
                  <div key={title} className="MainMenu__item">
                    <CoreLink className="MainMenu__item__link" to={url}>
                      <div className={classes}>{title}</div>
                    </CoreLink>
                  </div>
                );
              })}
            </>
          );
        }}
      </Menu>
    );
  };

  // Note: there are 2 font size pickers in this menu, this is
  // due to the structure of the navigation not allowing 1 fontsizepicker
  // for both desktop and mobile. In practice this shouldn't be an issue,
  // as only 1 fontsizepicker will be rendered at a time, and the chance
  // of someone switching between desktop and mobile views on one device
  // is minimal.
  return (
    <>
      <div className="MainMenu">
        <div id="MainMenu__bg" />
        {renderMenu()}
      </div>
      <div className={MainMenuMobileClasses}>
        <div className="Hamburger__wrapper">
          {!isOnSearchPage && (
            <a className="Hamburger__link" onClick={() => setSearchToggled(!searchToggled)}>
              <span>Zoeken</span>
              <div className={`icon icon--${searchToggled ? 'cross' : 'search'}`} />
            </a>
          )}
          {menuToggled === false ? (
            <div className="Hamburger__button" onClick={() => { setMenuToggled(true); }}>
              <span>Menu</span>
              <div className="Hamburger__icon icon-before icon-hamburger icon-variant-3" />
            </div>
          ) : (
            <div className="Hamburger__button" onClick={() => { setMenuToggled(false); }}>
              <span>Sluit</span>
              <div className="Hamburger__icon icon-before icon-cross icon-variant-3" />
            </div>
          )}
        </div>
        <div className="MainMenu__mobile__menu">
          {renderMenu()}
        </div>
      </div>
    </>
  );
};

export default MainMenu;
